<!-- 项目文件 -->
<template>
    <div>
        <div class="posfix w67 h67 top50p right0">
            <div class=" h100p" @click="open()">
                <span class="">
                    <img class="w67 h67" src="../../public/img/apply.png" alt="">
                </span>
            </div>
        </div>

        <!-- 入驻弹框 -->
        <div class="posfix w100p h100p bgrgba alit top0 left0 zindex9999" v-show="mask==1">
            <div class="mauto  bgfff w75p pt20 pb20 pl15 pr15 bradius8">
                <P class=" fbold fs18 c1f8 textc">申请入驻</P>
                <div class="">
                    <p class="posre bradius8  alit mt15 ">
                        <input v-model="School" class="pl4 pt8 pb8  baee bradius8 w100p h100p borderno outline fs14" type="text"
                            placeholder="请输入驾校名称...">
                    </p>
                    <p class="posre bradius8  alit mt15 ">
                        <input v-model="Name" class="pl4 pt8 pb8  baee bradius8 w100p h100p borderno outline fs14" type="text"
                            placeholder="请输入姓名...">
                    </p>
                    <p class="posre bradius8 alit mt15">
                        <input v-model="Phone" class="pl4 pt8 pb8 baee bradius8 w100p h100p borderno outline fs14" type="text"
                            placeholder="请输入手机号...">
                    </p>
                    <div class="overflow mt15">
                        <p @click="sentApply()"
                            class="floatl pt10 pb10 bradius8 cursor   cfff bg1f8 textc fbold fs15 w40p disinblock">
                            确认提交
                        </p>
                        <p @click="choose()"
                            class="floatr pt10 pb10 bradius8 cursor   cfff bgblue textc fbold fs15 w40p disinblock">
                            取消
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from "jquery";
    export default {
        data() {
            return {
                mask: 0,
                Name: '',
                Phone: '',
                School: '',
            };
        },
        methods: {
            open() {
                this.mask = 1;
                $('body').css("overflow", "hidden")
            },
            choose() {
                this.mask = 0;
                $('body').css("overflow", "auto")
            },
            sentApply() {
                let that = this;
                if (that.Name == "" || that.School == "" || !(/^1[23456789]\d{9}$/.test(that.Phone))) {
                    console.log(that.Name)
                    console.log(that.Phone)
                    alert('请正确输入');
                    return 0;
                } else {
                    $.ajax({
                        type: "POST",
                        url: that.beseSend + "/openapi/drivingin/insterDrivingin.json",
                        dataType: "json",
                        async: false,
                        data: {
                            "name": that.Name,
                            "phone": that.Phone,
                            'belongstoschool': that.School,
                            'channel': 'exejapp'
                        },
                        success: function(data) {
                            alert(data.resultObj.info)
                            that.choose();
                            that.Name = "";
                            that.Phone = "";
                            that.School = "";
                        },
                        error: function(data) {
                            console.log(data);
                        }
                    });
                }
            },
        },
        created() {

        },
        mounted() {

        },
    }
</script>
<style scoped>

</style>